var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-modal", {
    attrs: { "has-header": "", scrollable: "", open: "" },
    on: { close: _vm.closeClick },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "emd-text",
              { attrs: { size: "section", "data-testid": "modal-header" } },
              [_vm._v(" " + _vm._s(_vm.$t("modalheader")) + " ")]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("installments-table", {
              staticClass: "without-padding",
              attrs: { installments: _vm.installments },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }